<template>
  <div class="ts-capture_content_container ts-signup-portal">
    <header>
      <h4>Let's get started</h4>
    </header>

    <el-form class="ts-form" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :error="retrieveFieldError(modelState, 'personalDetails.firstName')"
            :required="true"
          >
            <label>First Name</label>
            <el-input type="text" v-model="currentRegistration.personalDetails.firstName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :error="retrieveFieldError(modelState, 'personalDetails.surname')"
            :required="true"
          >
            <label>Last Name</label>
            <el-input type="text" v-model="currentRegistration.personalDetails.surname"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item
        :error="retrieveFieldError(modelState, 'personalDetails.companyEmail')"
        :required="true"
      >
        <label>Your company email</label>
        <el-input placeholder="email@yourdomain.com" type="email" v-model="currentRegistration.PersonalDetails.companyEmail"></el-input>
      </el-form-item>

      <el-form-item
        :error="retrieveFieldError(modelState, 'personalDetails.password')"
        :required="true"
      >
        <label>Choose a password</label>
        <el-input type="password" v-model="currentRegistration.personalDetails.password"></el-input>
      </el-form-item>

      <el-form-item
        :error="retrieveFieldError(modelState, 'personalDetails.confirmPassword')"
        :required="true"
      >
        <label>Confirm password</label>
        <el-input
          type="password"
          v-model="currentRegistration.personalDetails.confirmPassword"
          class="mb10"
        ></el-input>
      </el-form-item>

      <div class="form-actions">
        <button
          v-on:click="storeSection()"
          class="ts-btn ts-btn-rounded ts-btn-secondary"
        >
          Next
        </button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  created() {
    if (this.currentRegistration.personalDetails == null) {
      this.currentRegistration.personalDetails = {};
    }
  },
  computed: {
    currentRegistration() {
      return this.$store.state.registration.current_registration;
    },
  },
  data() {
    return {
      isLoading: false,
      modelState: {},
    };
  },
  methods: {
    storeSection() {
      this.isLoading = true;

      this.$store
        .dispatch("registration/store", this.currentRegistration)
        .then((res) => {
          this.$router.app.$emit("navigateToNextStep");
        })
        .catch((res) => {
          this.modelState = res.errors;
        })
        .finally((res) => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss"></style>
